// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__1OK_o","description":"MealItem_description__34X9C","price":"MealItem_price__2ZzGH"};